import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: ({ spacing }) => spacing(1),
    minHeight: ({ spacing }) => spacing(3),
  },
  slotLeft: {
    flexShrink: 0,
  },
  slotRight: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: ({ spacing }) => spacing(1),
  },
} satisfies Record<string, SxProps<Theme>>
